import { Injectable, Inject, Optional, InjectionToken, DOCUMENT } from '@angular/core';

import type { TransitionService, Transition } from '@uirouter/angular';

export const ROUTE_TRANSITION_SCROLL_CONFIGURATION =
  new InjectionToken<RouteTransitionScrollConfiguration>('routeTransitionScrollConfiguration');

export interface RouteTransitionScrollConfiguration {
  scroll(): void;
}

@Injectable({
  providedIn: 'root'
})
export class RouterScrollService {
  private static readonly DEFAULT_ROOT_PARENT_STATE_NAME: string = 'page';

  constructor(@Inject(DOCUMENT) private document: Document,
              @Inject(ROUTE_TRANSITION_SCROLL_CONFIGURATION) @Optional()
              private routeTransitionScrollConfiguration: RouteTransitionScrollConfiguration) {
  }

  static initHooks(transitionService: TransitionService): void {
    transitionService.onSuccess(
      {
        to: RouterScrollService.DEFAULT_ROOT_PARENT_STATE_NAME + '.**',
        from: RouterScrollService.DEFAULT_ROOT_PARENT_STATE_NAME + '.**'
      },
      (transition: Transition): void => {
        const routerScrollService: RouterScrollService = transition.injector().get(RouterScrollService);
        routerScrollService.handlePageTransition(transition);
      });
  }

  scrollToTop(): void {
    this.document.body.scrollTop = this.document.documentElement.scrollTop = 0;
    // TODO temporary code while we are embedding new site into iframes on old site - remove when migration is complete
    if (this.routeTransitionScrollConfiguration !== undefined && this.routeTransitionScrollConfiguration !== null) {
      this.routeTransitionScrollConfiguration.scroll();
    }
  }

  private handlePageTransition(transition: Transition): void {
    const to  = transition.to();
    const from  = transition.from();

    let toRootParentState = to.data !== undefined ? to.data.rootParentState : undefined;
    let fromRootParentState = from.data !== undefined ? from.data.rootParentState : undefined;

    if (toRootParentState === undefined) {
      toRootParentState = RouterScrollService.DEFAULT_ROOT_PARENT_STATE_NAME;
    }

    if (fromRootParentState === undefined) {
      fromRootParentState = RouterScrollService.DEFAULT_ROOT_PARENT_STATE_NAME;
    }

    if (toRootParentState === fromRootParentState) {
      const toName = to.name.replace(toRootParentState + '.', '').split('.');
      const fromName = from.name.replace(fromRootParentState + '.', '').split('.');
      if (toName[0] !== fromName[0]) {
        this.scrollToTop();
      }
    } else {
      this.scrollToTop();
    }
  }
}
